"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tableCellStyles = require("./styles/tableCellStyles");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TableCell = _styledComponents["default"].td(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-bottom: 1px solid ", ";\n  padding: ", ";\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.tableBorderColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.tableCellPadding;
}, function (_ref3) {
  var isHead = _ref3.isHead;
  return isHead ? _tableCellStyles.getHeadStyles : _tableCellStyles.getDefaultStyles;
});
var _default = TableCell;
exports["default"] = _default;